import { ModuleLink } from "./ModuleLink/ModuleLink.jsx";
import { styles } from "./StageSchedule.css.ts";

/**
 * Component for rendering a schedule of modules for a specific stage.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {{ key: string, title: string, steps: object[], recommendedMinutes: number, disabled?: boolean }[]} props.modules - The module list (stations or procedures).
 * @param {string} props.baseUrl - The spark's base URL each module link is built from.
 * @returns {JSX.Element} Returns the rendered chapter schedule based on the given inputs.
 */
export const StageSchedule = ({ modules, baseUrl, disableSome }) => {
  const renderModules = () => {
    if (modules.length === 0) {
      return <p className={styles.noModulesInfo}>Keine Module an diesen Tag</p>;
    }

    return modules.map((mod) => (
      <ModuleLink
        key={mod.key}
        mod={mod}
        baseUrl={baseUrl}
        disableSome={disableSome}
      />
    ));
  };

  return (
    <div className={styles.moduleLinkList} id="chapter-schedule">
      {renderModules()}
    </div>
  );
};
